module.exports = __webpack_public_path__ + "static/media/icon-hot.7081798a.svg";